import { memo } from 'react';
import { useLocation } from 'react-router';

import { TableHeaderCellContentPrefab } from '@frontend/components';

import type { ColumnHorizontalAlignment, SortParam, SortValue } from '../types';

const SORT_BOTH = ['ascending', 'descending'] as const;

export type HeaderCellContentProps = {
  columnTitle: string;
  columnSortKey: string;
  columnHorizontalAlignment?: ColumnHorizontalAlignment;
  currentSort: SortValue;
  onSort: (sortKey: SortParam | null) => void;
};

export const HeaderCellContent = ({
  columnTitle,
  columnSortKey,
  columnHorizontalAlignment,
  currentSort,
  onSort,
}: HeaderCellContentProps) => {
  const location = useLocation();

  const incrementSort = (sortKey: string) => {
    if (location.search.includes(`o=-${sortKey}`)) {
      onSort(null);
    } else if (location.search.includes(`o=${sortKey}`)) {
      onSort(`-${sortKey}`);
    } else {
      onSort(sortKey);
    }
  };

  return (
    <TableHeaderCellContentPrefab
      columnTitle={columnTitle}
      sortPossibleDirections={SORT_BOTH}
      sortDirection={
        currentSort?.sortKey === columnSortKey
          ? currentSort.sortOrder
          : undefined
      }
      onIncrementSort={() => incrementSort(columnSortKey)}
      headerButtonProps={{ justifyContent: columnHorizontalAlignment }}
    />
  );
};

export const MemoizedHeaderCellContent = memo(HeaderCellContent);
